import React from 'react';
import Loader from 'react-loader-spinner';

interface IProps {
  fullHeight?: boolean;
  message?: React.ReactNode;
}

interface ILoadProgress {
  loaded: number;
  estimatedTotal?: number;
}

export const buildLoadingProgressMessage = (
  progress: ILoadProgress,
  itemLabel: string,
): string | undefined => {
  if (!progress.loaded) {
    return undefined;
  }

  const estimatedTotal = progress.estimatedTotal && progress.estimatedTotal > progress.loaded
    ? ` of roughly ${progress.estimatedTotal}`
    : '';
  return `Loaded ${progress.loaded}${estimatedTotal} ${itemLabel}...`;
};

export const Loading = ({ fullHeight, message }: IProps) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        minHeight: fullHeight ? 'calc(100vh - 220px)' : undefined,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: fullHeight ? '#FFFFFF' : undefined,
      }}
    >
      <Loader
        type='Puff'
        color='#FF621D'
        height={100}
        width={100}
      />
      {message && (
        <p
          className='studio-website-text'
          style={{
            marginTop: '12px',
            textAlign: 'center',
          }}
        >
          {message}
        </p>
      )}
    </div>);
};
